'use client'
import React, { useEffect, useState } from 'react'
import { useFormState, useFormStatus } from 'react-dom';
import { register } from '@/actions/authActions';
import { toast } from 'sonner';
import { useRouter } from 'next/navigation';
import CustomButton from '@/components/common/CustomButton';
import SeePasswordButton from '@/components/common/SeePasswordButton';

const RegisterForm = () => {

  const initialState = { status: '', message: '' };
  const [data, formAction] = useFormState(register, initialState);
  const isLocal = process.env.NODE_ENV === "development";
  const router = useRouter()

  const [seePassword, setSeePassword] = useState(false);

  useEffect(() => {
    if (data.status !== '') {
      if (data.status === 201) {
        toast.success("Cuenta creada con exito, ya puedes logearte")
        router.push(isLocal ? '/auth/login' : 'https://app.marinebroker.com.ar/auth/login')
      } else toast.error(data.message)
    }
  }, [data, router])

  return (
    <form action={formAction} className='w-full h-auto flex items-center justify-between flex-wrap gap-y-4'>
      <label className='w-full md:w-[48%] flex flex-col justify-center relative' >
        <div className='text-xs 2xl:text-sm font-semibold flex justify-between w-full'>Nombre</div>
        <input
          name='name'
          required
          minLength='1'
          maxLength='20'
          placeholder='Nombre y apellido'
          type='text'
          className='w-full h-11 xl:h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
        />
      </label>
      <label className='w-full md:w-[48%] flex flex-col justify-center relative' >
        <div className='text-xs 2xl:text-sm font-semibold flex justify-between w-full'>Mail</div>
        <input
          name='email'
          required
          minLength='1'
          maxLength='40'
          placeholder='miempresa@email.com...'
          type='email'
          className='w-full h-11 xl:h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
        />
      </label>
      <label className='w-full md:w-[48%] flex flex-col justify-center relative' >
        <div className='text-xs 2xl:text-sm font-semibold flex justify-between w-full'>DNI</div>
        <input
          name='dni'
          required
          minLength='7'
          maxLength='8'
          placeholder='Escribe tu DNI...'
          type='number'
          className='w-full h-11 xl:h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
        />
      </label>
      <label className='w-full md:w-[48%] flex flex-col justify-center relative' >
        <div className='text-xs 2xl:text-sm font-semibold flex justify-between w-full'>CUIT</div>
        <input
          name='cuit'
          required
          minLength='10'
          maxLength='11'
          placeholder='Escribe tu CUIT...'
          type='number'
          className='w-full h-11 xl:h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
        />
      </label>
      <label className=" w-full flex flex-col justify-center relative">
        <span className={`text-xs 2xl:text-sm font-semibold flex justify-between w-full`}>Contraseña</span>
        <input
          type={seePassword ? 'text' : 'password'}
          name='password'
          required
          minLength={8}
          maxLength={20}
          placeholder='*********'
          className='w-full h-11 xl:h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
        />
        <SeePasswordButton seePassword={seePassword} setSeePassword={setSeePassword} />
      </label>
      <label className='w-full flex flex-col justify-center relative' >
        <div className='text-xs 2xl:text-sm font-semibold flex justify-between w-full'>Confirmar contraseña</div>
        <input
          name='confirm_password'
          required
          minLength='8'
          maxLength='20'
          placeholder='*********'
          type='password'
          className='w-full h-11 xl:h-12 text-xs px-2 xl:text-sm rounded border border-gray-300 focus-within:border-gray-300 focus:border-gray-300'
        />
      </label>
      {/* <div className='flex gap-x-1'>
        <input type="checkbox" onChange={() => setTermsAreChecked(!termsAreChecked)} checked={termsAreChecked} />
        <p className='text-xs lg:text-sm text-gray-400'>Estoy de acuerdo con los<span className='text-primary font-medium'> términos y privacidad</span></p>
      </div> */}
      <RegisterButton />
    </form>
  )
}

function RegisterButton() {

  const { pending } = useFormStatus()

  return (
    <CustomButton type='submit' disabled={pending} title={pending ? 'Registrando...' : 'Registrarme'} colorType={pending ? 'disabled' : 'primary'} />
  )
}

export default RegisterForm